import React from "react";
import styles from "./styles.css";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Text } from "@cars24/turbo-web/lib/text";
import PropTypes from "prop-types";
import { Button } from "@cars24/turbo-web/lib/button";

const WhyPayChallans = ({ whyPayChallanData }) => {

    const { title = "", whyPayChallanList = [] } = whyPayChallanData || {};

    const { tokens } = useTokens();

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };

    return (
        <div styleName={"styles.stepsMainWrapper"} className="cvh">
            <div styleName={"styles.titleContainer"}>
                <Text size="450" fontWeight="semibold" as="h2" color={tokens.text_default_text_primary}>{title}</Text>
                <Button size="medium" variant="primary" label="Get challan details" onClick={goToTop} />
            </div>
            <div styleName={"styles.stepCardWrapper"}>
                {
                    whyPayChallanList.map((item, index) => (
                        <div key={index} styleName={"styles.stepCard"}>
                            <img src={item?.image?.url} alt={item?.description} />
                            <div styleName={"styles.stepCardTextWrapper"}>
                                <Text size="300" fontWeight="semibold" color={tokens.text_default_text_primary}>{item?.title}</Text>
                                <Text size="250" fontWeight="regular" color={tokens.text_default_text_secondary}>{item?.description}</Text>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

WhyPayChallans.propTypes = {
    whyPayChallanData: PropTypes.object
};

export default WhyPayChallans;
